import { ReactNode } from 'react';

export const giftCardImages = [
  {
    name: 'IKEA',
    image:
      'https://daymade-website-assets.s3.amazonaws.com/2026/referrals/gift-card-faqs/ikea.svg',
  },
  {
    name: 'Amazon',
    image:
      'https://daymade-website-assets.s3.amazonaws.com/2026/referrals/gift-card-faqs/amazon.svg',
  },
  {
    name: 'Apple',
    image:
      'https://daymade-website-assets.s3.amazonaws.com/2026/referrals/gift-card-faqs/apple.svg',
  },
  {
    name: 'John Lewis',
    image:
      'https://daymade-website-assets.s3.amazonaws.com/2026/referrals/gift-card-faqs/john-lewis.svg',
  },
  {
    name: 'Hotels.com',
    image:
      'https://daymade-website-assets.s3.amazonaws.com/2026/referrals/gift-card-faqs/hotels-com.svg',
  },
  {
    name: 'Selfridges',
    image:
      'https://daymade-website-assets.s3.amazonaws.com/2026/referrals/gift-card-faqs/selfridges.svg',
  },
  {
    name: 'lastminute.com',
    image:
      'https://daymade-website-assets.s3.amazonaws.com/2026/referrals/gift-card-faqs/last-minute.svg',
  },
  {
    name: 'Harvey Nichols',
    image:
      'https://daymade-website-assets.s3.amazonaws.com/2026/referrals/gift-card-faqs/harvey-nichols.svg',
  },
  {
    name: 'argos',
    image:
      'https://daymade-website-assets.s3.amazonaws.com/2026/referrals/gift-card-faqs/argos.svg',
  },
  {
    name: 'M&S',
    image:
      'https://daymade-website-assets.s3.amazonaws.com/2026/referrals/gift-card-faqs/marks-and-spencer.svg',
  },
  {
    name: 'Eurostar',
    image:
      'https://daymade-website-assets.s3.amazonaws.com/2026/referrals/gift-card-faqs/eurostar.svg',
  },
  {
    name: 'Airline Gift',
    image:
      'https://daymade-website-assets.s3.amazonaws.com/2026/referrals/gift-card-faqs/airline-gift.svg',
  },
];

export const giftCardFAQs: [question: string, answer: ReactNode][] = [
  [
    "When will I receive rewards from my friends' wins?",
    <>
      <p>
        If one of your invited friends wins a qualifying prize, your reward will
        be added to your account automatically within 3 hours of the draw.
        Rewards are paid after Tuesday or Friday draws, depending on when your
        friends play.
      </p>
    </>,
  ],
  [
    'What rewards can my friends unlock when I win?',
    <>
      <p>
        They can unlock the same kinds of rewards you can - from small treats,
        to gift cards, to the £5,000 gift card top prize.
      </p>
    </>,
  ],
  [
    'Do I have to invite all 3 friends?',
    <>
      <p>
        No. You can invite 1, 2 or up to 3 friends. The more friends you invite,
        the more chances you have to unlock shared rewards across the weekly
        draws. Just make sure the friends you invite are new to DAYMADE.
      </p>
    </>,
  ],
  [
    'What happens if my friend cancels?',
    <>
      <p>
        If your friend cancels, you will no longer receive any future shared
        wins from them.
      </p>
    </>,
  ],
];
